import { Button } from 'components/Button';
import { StackedRadioCardGroup } from 'components/Forms';
import { Heading } from 'components/Typography';
import { InsuranceContextV3, withInsuranceMachineStateV3 } from 'domains/signupv3/Insurance/context';
import { isUndefined, noop } from 'lodash';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  defaultValue?: boolean;
  onSubmit: (value: boolean) => void;
};

const EnterInsurance: React.FC<Props> = ({ defaultValue, onSubmit }) => {
  const { t } = useTranslation();

  const [value, setValue] = useState<boolean | undefined>(defaultValue);

  return (
    <>
      <Heading level="h2" className="mb-16">
        {t(`signup.direct.steps.enterUseInsurance.title`)}
      </Heading>
      <Heading level="h7" className="mb-64 sm-d:mb-40">
        {t(`signup.direct.steps.enterUseInsurance.subtitle`)}
      </Heading>
      <StackedRadioCardGroup
        label={t('screener.questions.singleSelectTitle')}
        className="gap-14"
        disabled={false}
        showSelectedDot
        options={[
          { label: 'Yes', value: 'true' },
          { label: 'No', value: 'false' },
        ]}
        value={!isUndefined(value) ? JSON.stringify(value) : undefined}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setValue(e.target.value === 'true');
        }}
        name="select-target"
        clearValue={noop}
        setError={noop}
        setValue={noop}
        tFunc={t}
        tPrefixKey="dropdowns.generic.trueFalse"
        autoFocus
      />

      <Button
        data-testid="insurance-submit-button"
        size="lg"
        className="mt-64 sm-d:mt-40 sm-d:w-full"
        onClick={() => {
          onSubmit(value as boolean);
        }}
        disabled={isUndefined(value)}
      >
        {t(`signup.direct.steps.enterUseInsurance.submit.continue`)}
      </Button>
    </>
  );
};

const InsuranceWrapper = () => {
  const useInsurance = InsuranceContextV3.useSelector(({ context }) => context.data.useInsurance);
  const { send } = InsuranceContextV3.useActorRef();

  const onSubmit = useCallback(
    (value: boolean) => {
      send({
        type: 'submitUseInsurance',
        useInsurance: value,
      });
    },
    [send],
  );

  return <EnterInsurance defaultValue={useInsurance} onSubmit={onSubmit} />;
};

export const InsuranceV3EnterUseInsurance = withInsuranceMachineStateV3(InsuranceWrapper, 'enterUseInsurance');
